/**
 * 指定した桁数に満たない場合は頭を0で埋めます。
 *
 * @param n {number} 数値
 * @param l {number} 長さ
 * @param p {string} 埋める文字列。初期値は '0'。
 * @returns {string}
 */
export function zeroPad(n, l, p = '0') {
    const padding = p.repeat(Math.max(0, l - String(n).length));
    return padding + n;
}
